import { isCN } from "./origin";

const isValidPromo = (promo?: string): boolean => {
  if (promo?.trim().length > 0 && !isCN) {
    return true;
  }

  return false;
};

export default isValidPromo;